import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface PageBannerProps {
  title: string;
  description?: string;
  breadcrumb?: Crumb[];
}

// 하위 페이지 공통 상단 배너 (제목 + 설명 + 브레드크럼)
export default function PageBanner({
  title,
  description,
  breadcrumb = [],
}: PageBannerProps) {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-10 md:py-14">
        {breadcrumb.length > 0 && (
          <nav aria-label="현재 위치" className="mb-4">
            <ol className="flex flex-wrap items-center gap-1.5 text-xs md:text-sm text-foreground-500">
              <li>
                <Link to="/" className="hover:text-primary-700">
                  홈
                </Link>
              </li>
              {breadcrumb.map((c, i) => (
                <li key={`${c.label}-${i}`} className="flex items-center gap-1.5">
                  <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
                  {c.to ? (
                    <Link to={c.to} className="hover:text-primary-700">
                      {c.label}
                    </Link>
                  ) : (
                    <span className="text-foreground-800 font-medium">{c.label}</span>
                  )}
                </li>
              ))}
            </ol>
          </nav>
        )}
        <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
          {title}
        </h1>
        {description && (
          <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
            {description}
          </p>
        )}
      </div>
    </section>
  );
}